import { PropsWithChildren } from 'react'

import { Badge } from '@/components/ui'
import { cn } from '@/lib/utils'
import CarbonDotMark from '~icons/carbon/dot-mark';

export type StatusVariance = 'primary' | 'warning' | 'secondary' | 'cancel' | 'danger'

export interface StatusBadgeProps extends PropsWithChildren {
  variance?: StatusVariance
}

const colorMap: Record<
  StatusVariance,
  {
    color: string
    bg: string
  }
> = {
  secondary: {
    color: 'text-muted-foreground',
    bg: 'bg-muted',
  },
  warning: {
    color: 'text-amber-900 dark:text-amber-100',
    bg: 'bg-amber-100 dark:bg-amber-950',
  },
  primary: {
    color: 'text-white',
    bg: 'bg-s-brand-primary-hover',
  },
  cancel: {
    color: 'text-white',
    bg: 'bg-destructive/10',
  },
  danger: {
    color: 'text-white',
    bg: 'bg-red-600',
  },
}

export function StatusBadge({ variance = 'secondary', children }: StatusBadgeProps) {
  const colorConfig = colorMap[variance] ?? colorMap.secondary

  return (
    <Badge
      className={cn(
        'flex h-9 items-center justify-start gap-1 rounded-md border-transparent font-normal',
        colorConfig.color,
        colorConfig.bg,
      )}
      variant="secondary"
    >
      <CarbonDotMark className={cn('h-4 w-4 shrink-0', colorConfig.color)} />
      <span className="text-sm font-normal">{children}</span>
    </Badge>
  )
}
